import React, { useEffect, useState } from "react"
import { Select, Spin } from "antd"
import { useSetState } from "react-use"
import { debounce } from "lodash"
import { getStages } from "~/services/apis"

const DEFAULT_PARAMS = {
  limit: 100,
  page: 1,
  search: "",
}

const StageSelect = ({
  disabled,
  procedureId,
  className,
  multiple = false,
  value = null,
  onChange = () => {},
  excludes = [],
  allowClear = true,
  ...props
}) => {
  const [params, setParams] = useSetState({ ...DEFAULT_PARAMS })
  const [stages, setStages] = useState([])
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false)

  const appendData = async () => {
    setLoading(true)
    try {
      const { data, headers } = await getStages({ ...params }, { procedureId })

      setMeta((headers && JSON.parse(headers.get("meta"))) || {})
      setStages([
        ...(params.page === 1 ? [] : stages),
        ...(data?.stages || [])
          ?.filter((stage) => !excludes.includes(stage?.id))
          ?.map((stage) => {
            return {
              label: stage?.name,
              value: stage?.id,
              procedureId: stage?.procedureId,
            }
          }),
      ])
    } catch (e) {
      console.log(e.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    appendData()
    // eslint-disable-next-line
  }, [params, procedureId])

  const onScroll = (e) => {
    if (
      !loading &&
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight
    ) {
      params.page < meta?.totalPages && setParams({ page: params.page + 1 })
    }
  }

  return (
    <Select
      labelInValue
      value={value}
      showSearch={true}
      notFoundContent={"Không tìm thấy giai đoạn"}
      onPopupScroll={onScroll}
      onSearch={debounce((search) => setParams({ search, page: 1 }), 300)}
      mode={multiple && "multiple"}
      options={stages}
      onChange={onChange}
      allowClear={allowClear}
      filterOption={false}
      dropdownRender={(menu) => (
        <>
          {menu}
          {loading && (
            <div className="place-center" style={{ padding: "8px 0" }}>
              <Spin />
            </div>
          )}
        </>
      )}
      onClear={() => onChange(null)}
      className={className}
      placeholder="Chọn giai đoạn"
      disabled={disabled}
      {...props}
    />
  )
}

export default StageSelect
